import { render, staticRenderFns } from "./TransferDays.vue?vue&type=template&id=8a4c5f0e&"
import script from "./TransferDays.vue?vue&type=script&lang=js&"
export * from "./TransferDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports